export const selectedBtnStyle = {
  backgroundColor: "#0956A8",
  borderColor: "#0956A8",
  color: "#fff",
};
